// extracted by mini-css-extract-plugin
export default {"base":"-cm_d704694f","button":"-cm_1f7c1714","searchLink":"-cm_dd5d7130","bookmarkLink":"-cm_b8e2e094","body":"-cm_e05c994b","notificationLight":"-cm_a7b9c10b"};